import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./Header.module.scss";

// İkonlar
import menu_icon from "../../assets/images/header/icons/menu.svg";
import menu_icon_white from "../../assets/images/header/icons/menu_white.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/header/icons/close.svg";
import logo from "../../assets/images/site-logo/logo.svg";
import mobile_logo from "../../assets/images/site-logo/mobile_logo.svg";
import mobile_logo_white from "../../assets/images/site-logo/mobile_logo_white.svg";
import PersonIcon from "../../assets/images/header/icons/ion_person.svg";
import LogoWhite from "../../assets/images/BscWhiteLogo.svg";

// Navigasiya və Komponentlər
import { navigation } from "../../constants/navigations.constant";
import { Link, NavLink, useLocation } from "react-router-dom";
import Button from "../../components/shared/Button/MainButton";
import UserInfoDropdown from "../../components/user-info-dropdown/UserInfoDropdown";
import SearchDropDown from "../../components/search-dropdown/SearchDropDown";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import BasketDrawer from "../../components/ui/basket-drawer/BasketDrawer";
import { fetchUserData, setIsUser } from "../../redux/Slices/userSlice";
import HeaderDropdownProducts from "../../components/header/header-dropdown/HeaderDropdownProducts";
import HeaderDropDownMobile from "../../components/header/header-dropdown-mobile/HeaderDropDownMobile";
import HeaderProductCategories from "./headerServices/HeaderServices";
import { getTranslations } from "../../redux/Slices/dictionarySlice";
import { useAppDispatch } from "../../hooks/hook";
import { ApiCategory, ApiSubCategory, LanguageDataType } from "./types/types";
import { setLanguage } from "../../redux/Slices/languageSlice";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ThemeToggle from "../../components/theme/Theme";
import { useTypingPlaceholder } from "../../hooks/useTypingPlaceholder";

// Yeni İkonlar
import { FiPhoneCall, FiSearch, FiChevronRight } from "react-icons/fi";
import { FaRegHeart } from "react-icons/fa";
import { SlBasket } from "react-icons/sl";
import { BiCategory } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { HiOutlineUser } from "react-icons/hi";

const Header: React.FC = () => {
  const theme = useSelector((state: RootState) => state.theme.mode);

  // İkonları dəyişən kimi təyin edirik
  const SearchIcon = FiSearch as any;
  const User = HiOutlineUser as any;
  const PhoneIcon = FiPhoneCall as any;
  const HeartIcon = FaRegHeart as any;
  const Basket = SlBasket as any;
  const BiCategoryIcon = BiCategory as any;
  const CloseSearchIcon = IoClose as any;
  const ChevronRightIcon = FiChevronRight as any;

  const location = useLocation();
  const dispatch = useDispatch();
  const dispatch_ = useAppDispatch();
  const token = localStorage.getItem("BscToken");

  // State-lər
  const [activeCategory, setActiveCategory] = useState<ApiCategory[] | null>(
    null,
  );
  const [hoveredCategory, setHoveredCategory] = useState<string | null>(null);
  const [activeItems, setActiveItems] = useState<ApiSubCategory[] | null>(null);
  const [isUserInfoDropdown, setIsUserInfoDropdown] = useState(false);
  const [isLangOpen, setLangOpen] = useState(false);
  const [lang, setLang] = useState<LanguageDataType[] | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [otherLinks, setOtherLinks] = useState(false);
  const [isSearchDropdown, setIsSearchDropdown] = useState(false);
  const [path, setPath] = useState<string>("");
  const [mobileNavbar, setMobileNavbar] = useState(false);
  const [isBasketOpen, setIsBasketOpen] = useState(false);
  const [categories, setCategories] = useState<ApiCategory[]>([]);
  const [services, setServices] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchData, setSearchData] = useState<any[]>([]);
  const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  // Refs
  const userInfoDropdownRef = useRef<HTMLDivElement>(null);
  const searchDropdownRef = useRef<HTMLDivElement>(null);
  const languageModalRef = useRef<HTMLUListElement>(null);
  const navbarRef = useRef<HTMLDivElement>(null);
  const productsDropdownRef = useRef<HTMLDivElement>(null);
  const mobileSearchInputRef = useRef<HTMLInputElement>(null);
  const catalogWrapperRef = useRef<HTMLDivElement>(null);

  // Redux Data
  const totalQuantity = useSelector(
    (state: RootState) => state.basket.totalQuantity,
  );
  const favoritesCount = useSelector(
    (state: RootState) => state.favorites.favoritesCount,
  );
  const user = useSelector((state: RootState) => state.user.userData);
  const translations = useSelector(
    (state: RootState) => state.translations.data,
  );
  const selectedLanguage = useSelector(
    (state: RootState) => state.language.selectedLanguage,
  );
  const categoryNames = categories.length > 0 ? categories.map((cat) => `${cat.name}...`) : [""]
  
      
   
  // console.log(categories,'dil')

  const animatedPlaceholder = useTypingPlaceholder(categoryNames,selectedLanguage);

  // Handlers
  const handleLanguageSelect = (lang: LanguageDataType) => {
    setIsDropdownOpen(false);
    dispatch(setLanguage(lang));
  };

  useEffect(() => {
    if (token) {
      dispatch_(fetchUserData());
    }
  }, [dispatch_, selectedLanguage, token]);

  useEffect(() => {
    if (selectedLanguage) {
      dispatch_(getTranslations());
    }
  }, [dispatch_, selectedLanguage]);

  const fetchData = useCallback(async () => {
    try {
      const data = await HeaderProductCategories.AllHeaderProductCategories();
      console.log(data, "salam");

      setCategories(data.data.data);
    } catch (error) {
      console.error("Məlumat alınmadı:", error);
    }
  },[selectedLanguage?.code])

  // Data Fetching
  useEffect(() => {
    fetchData();
  }, [selectedLanguage]);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await HeaderProductCategories.getLanguegs();
        const languages = response.data.data;
        setLang(languages);
        const storedLangCode = localStorage.getItem("bsc-lang");
        const foundLang = languages.find(
          (item: LanguageDataType) => item.code === storedLangCode,
        );
        if (foundLang) {
          dispatch(setLanguage(foundLang));
        } else {
          dispatch(setLanguage(languages[0]));
        }
      } catch (error) {
        console.error("Dillər alınmadı:", error);
      }
    };
    fetchLanguages();
  }, [dispatch]);

  // Click Outside logic
  useEffect(() => {
    const handleClickOutsideSearch = (event: MouseEvent) => {
      if (
        searchDropdownRef.current &&
        !searchDropdownRef.current.contains(event.target as Node) &&
        !mobileSearchInputRef.current?.contains(event.target as Node)
      ) {
        // Handle click outside search
      }
    };
    document.addEventListener("mousedown", handleClickOutsideSearch);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSearch);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await HeaderProductCategories.AllHeaderServices();
        setServices(data.data.data);
      } catch (error) {}
    };
    fetchData();
  }, [selectedLanguage]);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        userInfoDropdownRef.current &&
        !userInfoDropdownRef.current.contains(event.target)
      ) {
        setIsUserInfoDropdown(false);
      }
      if (
        languageModalRef.current &&
        !languageModalRef.current.contains(event.target)
      ) {
        setLangOpen(false);
      }
      if (
        productsDropdownRef.current &&
        !productsDropdownRef.current.contains(event.target) &&
        !event.target.closest(`.${styles.nav_list}`)?.contains(event.target) &&
        !event.target
          .closest(`.${styles.catalog_wrapper}`)
          ?.contains(event.target)
      ) {
        setActiveCategory(null);
        setHoveredCategory(null);
        setIsDropdownOpen(false);
        setPath("");
      }
      const favoritesPanel = document.querySelector(
        `.${styles.favorites_panel}`,
      );
      if (favoritesPanel && !favoritesPanel.contains(event.target)) {
        setIsFavoritesOpen(false);
      }
      if (
        catalogWrapperRef.current &&
        !catalogWrapperRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
        setActiveCategory(null);
        setHoveredCategory(null);
        setPath("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const getToken = () => {
      const token = localStorage.getItem("BscToken");
      if (token) {
        dispatch(setIsUser(true));
      } else {
        dispatch(setIsUser(false));
      }
    };
    getToken();
  }, [dispatch]);

  const toggleDropdown = () => {
    setLangOpen((prevState) => !prevState);
  };

  useEffect(() => {
    if (!mobileNavbar) {
      setPath("");
    }
  }, [mobileNavbar]);

  const handleCategoryHover = (type: "products" | "services"): void => {
    if (window.innerWidth <= 1024) return;
    if (path === type && isDropdownOpen) return;

    setPath(type);
    if (type === "products") {
      const transformedCategories: ApiCategory[] = categories.map(
        (category) => ({
          ...category,
          children: category.children?.map((subCategory) => ({
            ...subCategory,
            children: subCategory.children?.map((item) => ({
              id: item.id,
              name: item.name,
              parent_id: item.parent_id,
            })),
          })),
        }),
      );
      setActiveCategory(transformedCategories);
    } else if (type === "services") {
      setActiveCategory(services);
    }
    setIsDropdownOpen(true);
  };

  const handleDropdownClick = (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    type: "products" | "services",
  ): void => {
    if (window.innerWidth <= 1024) {
      e.preventDefault();
      setPath(type === path ? "" : type);

      if (type === "products") {
        setActiveCategory(categories);
      } else {
        setActiveCategory(services);
      }
      setIsDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    setActiveCategory(null);
    setHoveredCategory(null);
    setIsDropdownOpen(false);
    setIsUserInfoDropdown(false);
    setPath("");
  };

  useEffect(() => {
    setIsDropdownOpen(false);
    setIsUserInfoDropdown(false);
    setMobileSearchOpen(false);
    setSearchValue("");
    setSearchData([]);
  }, [location]);

  // !!! DİQQƏT: Avtomatik yönləndirməni sildim ki, burger menyu açılanda bütün linklər görünsün !!!
  // useEffect(() => {
  //   if (mobileNavbar) {
  //     const firstCategory = navigation.find((nav) => nav.dropdown);
  //     if (firstCategory) {
  //       setPath("products");
  //     }
  //   }
  // }, [mobileNavbar]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setMobileNavbar(false);
        setOtherLinks(false);
        setMobileSearchOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeMobileNavbar = () => {
    setMobileNavbar(false);
    setTimeout(() => setOtherLinks(false), 300);
  };

  const searchHandler = async (value: string) => {
    setSearchValue(value);
    if (value.trim() === "") {
      setSearchData([]);
      return;
    }
    setLoading(true);
    try {
      const response = await HeaderProductCategories.getSearchProduct(value);
      if (response.data?.products?.length > 0) {
        setSearchData(response.data.products);
      } else {
        setSearchData([]);
      }
    } catch (error) {
      console.error("Axtarış zamanı xəta:", error);
      setSearchData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchResultClose = () => {
    setSearchData([]);
    setSearchValue("");
    setIsSearchDropdown(false);
    setMobileSearchOpen(false);
  };

  // Remove top-level skeleton to prevent CLS
  // if (translations?.Loading) {
  //   return <Skeleton count={5} />;
  // }

  return (
    <header id={styles.header}>
      {/* ------------------ TOP HEADER ------------------ */}
      <div
        style={{ backgroundColor: theme === "dark" ? "rgb(63, 63, 63)" : " " }}
        className={styles.header_top}
      >
        <div className={styles.header_top_content}>
          <div className={styles.navlink_container}>
            <ul className={styles.navlink_lists}>
              <li className={styles.nav_list}>
                <NavLink
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ""} ${
                      theme === "dark" ? styles.dark : ""
                    }`
                  }
                  to="/about"
                >
                  {translations?.about_us}
                </NavLink>
              </li>
              <li className={styles.nav_list}>
                <NavLink
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ""} ${
                      theme === "dark" ? styles.dark : ""
                    }`
                  }
                  to="/contact"
                >
                  {translations?.contact}
                </NavLink>
              </li>
            </ul>
          </div>

          <div className={styles.header_top_right}>
            <Link
              to="/campaigns"
              className={`${styles.campaign_btn} ${
                theme === "dark"
                  ? styles.campaign_btn_dark
                  : styles.campaign_btn_light
              }`}
            >
              {translations?.campaigns || "Kampaniyalar"}
            </Link>

            <ThemeToggle />

            <div className={styles.end}>
              <a href="tel:991" className={styles.header_end}>
                <PhoneIcon
                  size={18}
                  color={theme === "dark" ? "#FFFFFF" : "#000000"}
                  style={{ transition: "color 0.3s ease" }}
                />
                <p className={styles.end_text}>991</p>
              </a>
            </div>

            {/* DİL SEÇİMİ */}
            {!mobileNavbar && (
              <div
                className={styles.header_lang}
                style={{ position: "relative" }}
              >
                <div
                  className={styles.language_button}
                  onClick={toggleDropdown}
                >
                  {selectedLanguage?.code && (
                    <img
                      src={selectedLanguage.image}
                      alt="language"
                      className={styles.language_icon}
                      width="22"
                      height="11"
                    />
                  )}
                  <span className={styles.selected_text}>
                    {selectedLanguage?.code}
                  </span>
                </div>
                {isLangOpen && (
                  <ul className={styles.language_list} ref={languageModalRef}>
                    {lang?.map((item: any) => (
                      <li
                        key={item.id}
                        onClick={() => {
                          handleLanguageSelect(item);
                          setLangOpen(!isLangOpen);
                        }}
                        className={styles.language_item}
                      >
                        <img
                          src={item.image}
                          alt={item.code}
                          className={styles.language_flag}
                          width="22"
                          height="11"
                        />
                        <span className={styles.selected_text}>
                          {item.code}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        style={{ backgroundColor: theme === "dark" ? "rgb(38, 38, 38)" : " " }}
        className={styles.header_bottom}
      >
        <div className="container">
          <div className={styles.header_bottom_content}>
            {/* 1. MOBİL AXTARIŞ PANELİ (Overlay) */}
            <div
              className={`${styles.mobile_search_bar} ${mobileSearchOpen ? styles.active : ""}`}
            >
              <div className={styles.search_inner}>
                <SearchIcon
                  size={20}
                  color="#999"
                  className={styles.input_icon}
                />
                <input
                  ref={mobileSearchInputRef}
                  type="text"
                  placeholder={
                    animatedPlaceholder ||
                    translations?.search_placeholder ||
                    "Məhsul axtarın..."
                  }
                  value={searchValue}
                  onChange={(e) => searchHandler(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      (e.target as HTMLInputElement).blur();
                    }
                  }}
                />
                <button
                  className={styles.close_btn}
                  onClick={() => {
                    setMobileSearchOpen(false);
                    setSearchValue("");
                    setSearchData([]);
                  }}
                >
                  <CloseSearchIcon
                    size={24}
                    color={theme === "dark" ? "#333" : "#333"}
                  />
                </button>
              </div>
            </div>

            {/* 2. STANDART HEADER CONTENT (Logo, Menyu, İkonlar) */}
            <div
              className={`${styles.standard_content} ${mobileSearchOpen ? styles.hidden : ""}`}
            >
              {/* SOL TƏRƏF */}
              <div className={styles.header_bottom_start}>
                <div
                  className={styles.menu_icon}
                  onClick={() => {
                    setMobileNavbar(!mobileNavbar);
                    setOtherLinks(true);
                  }}
                >
                  <img
                    src={theme === "dark" ? menu_icon_white : menu_icon}
                    alt="menu"
                    width="24"
                    height="24"
                  />
                </div>
                <a href="/" className={styles.logo}>
                  <img
                    src={theme === "dark" ? LogoWhite : logo}
                    alt="logo"
                    width="160"
                    height="45"
                  />
                </a>
                <a href="/" className={styles.mobile_logo}>
                  <img
                    src={theme === "dark" ? mobile_logo_white : mobile_logo}
                    alt="logo"
                    width="45"
                    height="45"
                  />
                </a>
              </div>

              {/* DESKTOP (Kataloq & Axtarış) */}
              {!mobileNavbar && (
                <>
                  <div
                    className={styles.catalog_wrapper}
                    ref={catalogWrapperRef}
                    onMouseLeave={handleMouseLeave}
                  >
                    <button className={styles.catalog_btn}>
                      <BiCategoryIcon size={24} color="#fff" />
                      <span>Kataloq</span>
                    </button>
                    <ul
                      className={`${styles.catalog_dropdown} ${isDropdownOpen ? styles.active : ""}`}
                    >
                      <li>
                        <div
                          onMouseEnter={() => handleCategoryHover("products")}
                          className={`${styles.link_item} ${theme === "dark" ? styles.dark : ""} ${path === "products" ? styles.active : ""}`}
                          style={{ cursor: "pointer" }}
                        >
                          {translations?.products || "Məhsullar"}
                          <ChevronRightIcon size={18} />
                        </div>
                      </li>
                      <li>
                        <div
                          onMouseEnter={() => handleCategoryHover("services")}
                          className={`${styles.link_item} ${theme === "dark" ? styles.dark : ""} ${path === "services" ? styles.active : ""}`}
                          style={{ cursor: "pointer" }}
                        >
                          {translations?.services || "Xidmətlər"}
                          <ChevronRightIcon size={18} />
                        </div>
                      </li>
                    </ul>

                    {isDropdownOpen && activeCategory && !mobileNavbar && (
                      <div
                        ref={productsDropdownRef}
                        className={styles.mega_menu_wrapper}
                      >
                        <HeaderDropdownProducts
                          path={path}
                          onMouseEnter={() =>
                            setHoveredCategory(hoveredCategory)
                          }
                          onMouseLeave={handleMouseLeave}
                          activeCategory={activeCategory}
                          hoveredCategory={hoveredCategory}
                          activeItems={activeItems}
                          setHoveredCategory={setHoveredCategory}
                          setActiveItems={setActiveItems}
                          translations={translations}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}

              <div className={styles.header_search_wrapper}>
                <div className={styles.header_search_wrapper}>
                  <div
                    className={`${styles.search_box} ${
                      theme === "dark"
                        ? styles.search_box_dark
                        : styles.search_box_light
                    }`}
                  >
                    <input
                      type="text"
                      className={styles.search_input}
                      placeholder={animatedPlaceholder}
                      value={searchValue}
                      onChange={(e) => searchHandler(e.target.value)}
                    />
                    <button className={styles.search_button}>
                      <SearchIcon size={20} color={"#2F2B54"} />
                    </button>
                  </div>
                </div>
              </div>

              {/* SAĞ TƏRƏF (İkonlar) */}
              <div className={styles.header_bottom_end}>
                <div className={styles.functional_icons}>
                  {/* MOBİL SEARCH ICON */}
                  <div
                    className={`${styles.icon_box} ${styles.mobile_search_icon}`}
                    onClick={() => {
                      setMobileSearchOpen(true);
                      setTimeout(
                        () => mobileSearchInputRef.current?.focus(),
                        100,
                      );
                    }}
                  >
                    <SearchIcon
                      size={26}
                      color={theme === "dark" ? "#fff" : "#2F2B54"}
                      style={{ transition: "color 0.3s ease" }}
                    />
                  </div>

                  {/* Favorilər */}
                  <div className={styles.icon_box}>
                    <div className={styles.count_wrapper}>
                      <p className={styles.icon_text}>
                        {token ? favoritesCount : 0}
                      </p>
                    </div>
                    <Link
                      to="/favourites"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsFavoritesOpen(!isFavoritesOpen);
                      }}
                    >
                      <HeartIcon
                        size={26}
                        color={theme === "dark" ? "#fff" : "#2F2B54"}
                        style={{ transition: "color 0.3s ease" }}
                      />
                    </Link>
                  </div>

                  {/* Səbət */}
                  <div
                    className={styles.icon_box}
                    onClick={() => setIsBasketOpen(true)}
                  >
                    <div className={styles.count_wrapper}>
                      <p className={styles.icon_text}>{totalQuantity}</p>
                    </div>
                    <Link
                      to="/"
                      className={styles.homeProductCard}
                      aria-label={translations?.basket || "Basket"}
                      onClick={(e) => e.preventDefault()}
                    >
                      <Basket
                        size={26}
                        color={theme === "dark" ? "#fff" : "#2F2B54"}
                        style={{ transition: "color 0.3s ease" }}
                      />
                    </Link>
                  </div>
                </div>

                {/* User Login */}
                {token ? (
                  <div className={styles.functional_icons}>
                    <div
                      className={styles.icon_box}
                      // onClick={(e) => e.preventDefault()}
                    >
                      <button
                        onClick={() => setIsUserInfoDropdown((prev) => !prev)}
                        className={styles.homeProductCard}
                      >
                        {
                          <User
                            size={26}
                            color={theme === "dark" ? "#fff" : "#2F2B54"}
                          />
                        }
                        {/* <img
                        
                          src={PersonIcon}
                          alt="User profile"
                          
                        /> */}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className={styles.header_login_btn}>
                    <Link to="/login">
                      <Button
                        text={translations?.login}
                        className={`${
                          theme === "dark"
                            ? styles.login_btn_dark
                            : styles.login_btn_light
                        }`}
                      />
                    </Link>
                  </div>
                )}
              </div>
            </div>
            {/* --- Standart Header End --- */}

            {/* Mobil Navbar Drawer (Yenilənmiş Hissə) */}
            <div
              ref={navbarRef}
              className={`${styles.navbar} ${mobileNavbar ? styles.open : ""}`}
            >
              {mobileNavbar && (
                <div className={styles.mobile_header}>
                  <div className={styles.x_icon} onClick={closeMobileNavbar}>
                    <CloseIcon
                    // style={{ color: theme === "light" ? "black" : "white" }}
                    />
                  </div>
                </div>
              )}

              {/* Sizin göndərdiyiniz HTML strukturuna əsasən qurulan menu */}
              {mobileNavbar && (
                <div className={styles.mobile_navlinks}>
                  <ul className={styles.mobile_nav_list}>
                    <li>
                      <NavLink
                        to="/services"
                        onClick={(e) => handleDropdownClick(e, "services")}
                        className={`${styles.mobile_link} ${path === "services" ? styles.active : ""}`}
                        style={{ cursor: "pointer" }}
                      >
                        {translations?.services || "Xidmətlər"}
                      </NavLink>
                    </li>
                    <li>
                      <div
                        onClick={(e) => handleDropdownClick(e, "products")}
                        className={`${styles.mobile_link} ${path === "products" ? styles.active : ""}`}
                        style={{ cursor: "pointer" }}
                      >
                        {translations?.products || "Məhsullar"}
                      </div>
                    </li>
                    <li>
                      <NavLink
                        to="/campaigns"
                        onClick={closeMobileNavbar}
                        className={({ isActive }) =>
                          `${styles.mobile_link} ${isActive ? styles.active : ""}`
                        }
                      >
                        {translations?.campaigns || "Kampaniyalar"}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/about"
                        onClick={closeMobileNavbar}
                        className={({ isActive }) =>
                          `${styles.mobile_link} ${isActive ? styles.active : ""}`
                        }
                      >
                        {translations?.about_us || "Haqqımızda"}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/contact"
                        onClick={closeMobileNavbar}
                        className={({ isActive }) =>
                          `${styles.mobile_link} ${isActive ? styles.active : ""}`
                        }
                      >
                        {translations?.contact || "Əlaqə"}
                      </NavLink>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown hissəsi - Yalnız path (Məhsullar/Xidmətlər) seçildikdə görünəcək */}
              {mobileNavbar && path && (
                <HeaderDropDownMobile
                  path={path}
                  onClick={() => setHoveredCategory(hoveredCategory)}
                  activeCategory={path === "services" ? services : categories}
                  isMobileDropdownOpen={mobileNavbar}
                  setMobileNavbar={setMobileNavbar}
                  translations={translations}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Dropdowns & Modals */}
      {isUserInfoDropdown && (
        <div ref={userInfoDropdownRef}>
          <UserInfoDropdown
            onMouseEnter={() => setHoveredCategory(hoveredCategory)}
            onMouseLeave={handleMouseLeave}
            user={user}
            translations={translations}
          />
        </div>
      )}

      {/* Axtarış Nəticələri */}
      {searchValue.trim() !== "" && (
        <div ref={searchDropdownRef}>
          <SearchDropDown
            onMouseEnter={() => setHoveredCategory(hoveredCategory)}
            onMouseLeave={handleMouseLeave}
            translations={translations}
            searchData={searchData}
            loading={loading}
            searchValue={searchValue}
            onItemClick={handleSearchResultClose}
          />
        </div>
      )}

      {isBasketOpen && (
        <BasketDrawer isOpen={isBasketOpen} setIsOpen={setIsBasketOpen} />
      )}
    </header>
  );
};

export default Header;
